<template>
    <div id="app">
        <keep-alive>
            <the-header></the-header>
        </keep-alive>

        <router-view></router-view>

        <keep-alive>
            <the-sign></the-sign>
        </keep-alive>

        <keep-alive>
            <the-footer v-show="$route.name !== 'app'"></the-footer>
        </keep-alive>

        <transition name="msg">
            <div v-show="msg.suc_show" class="msg-box">
                <div class="msg-box-main">
                    <i class="icon-success dc"></i>
                    <span class="msg-text">{{msg.suc_msg}}</span>
                </div>
            </div>
        </transition>

        <transition name="msg">
            <div v-show="msg.err_show" class="msg-box"><i class="icon-error dc"></i><span class="msg-text">{{msg.err_msg}}</span></div>
        </transition>

        <!--提示组件-->
        <transition name="confirm-box">
            <div class="confirm-box im" v-show="confirm.show">
                <div class="confirm-box-mask" @click="confirm.show = false"></div>
                <transition name="confirm">
                    <div class="confirm-box-main" v-if="confirm.show">
                        <div class="confirm-header-box">
                            <div class="confirm-title">{{confirm.title}}</div>
                            <i class="icon-close" @click="confirm.show = false"></i>
                        </div>
                        <div class="confirm-content-box">
                            <i class="icon-warning">!</i>
                            <p class="confirm-text">{{confirm.content}}</p>
                        </div>
                        <div class="confirm-button-box">
                            <span class="confirm-button confirm-button-cancel" @click="cancel">{{confirm.cancel}}</span>
                            <span class="confirm-button bg" @click="sure">{{confirm.sure}}</span>
                        </div>
                    </div>
                </transition>
            </div>
        </transition>

        <transition name="to-top">
            <i v-show="toTop" @click="backTop" class="icon-b-arrow to-top df jcc ac pf cp"></i>
        </transition>
    </div>
</template>

<script>
    import TheHeader from './common/TheHeader.vue'
    import TheSign from './common/TheSign.vue'
    import TheFooter from './common/TheFooter.vue'

    export default {
        components: {
            TheHeader,
            TheSign,
            TheFooter,
        },
        data: () => ({
            toTop: false,
        }),
        methods: {
            sure() {
                this.confirm.show = false;
                this.confirm.sureCb();
            },
            cancel() {
                this.confirm.show = false;
                this.confirm.cancelCb && this.confirm.cancelCb();
            },
            scroll() {
                const scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
                if (scrollTop > 500 && !this.toTop) this.toTop = true;
                if (scrollTop < 500 && this.toTop) this.toTop = false;
            },
            backTop() {
                window.scrollTo(0, 0);
            }
        },
        computed: {
            msg() {
                return this.$store.state.msg;
            },
            confirm() {
                return this.$store.state.confirm;
            }
        },
        beforeCreate() {
            let {user} = this.$store.state, volume = window.localStorage.volume;
            if (user.id) {
                this.api.get('users/info').then(e => {
                    for (let k in e) {
                        user[k] = e[k];
                    }
                    window.localStorage.user = JSON.stringify(user);// 存入localStorage
                }, () => {
                    this.alert.err('获取用户信息失败, 请尝试刷新页面');
                });
            }
            if (volume) {
                this.$store.state.video.volume = volume;
            }
        },
        mounted() {
            window.addEventListener('scroll', this.scroll);
        }
    }
</script>

<style>
    @import '../static/css/common/icon.css';
    @import '../static/css/common/wave.css';
    @import '../static/css/common/element.css';
    @import '../static/css/common/common.css';
</style>



// WEBPACK FOOTER //
// src/App.vue